import { createContext, useContext, ReactNode } from 'react';
import { useTronSocket, TronSocketData } from '@/hooks/useTronSocket';

interface TronSocketContextType {
  data: TronSocketData;
  isConnected: boolean;
  reconnect: () => void;
}

const TronSocketContext = createContext<TronSocketContextType | null>(null);

export const TronSocketProvider = ({ children }: { children: ReactNode }) => {
  const socketData = useTronSocket();
  
  return (
    <TronSocketContext.Provider value={socketData}>
      {children}
    </TronSocketContext.Provider>
  );
};

export const useTronSocketContext = () => {
  const context = useContext(TronSocketContext);
  if (!context) {
    throw new Error('useTronSocketContext must be used within TronSocketProvider');
  }
  return context;
};
